import { useEffect, useState } from "react";
import Service from "../../service";

const DEFAULT_BRANDING = { companyName: "", companyLogoUrl: null, companyFavIcoUrl: null, currency: "INR", dateFormat: "DD-MM-YYYY", fileUploadSize: 1 };

const brandingCache = new Map();

/** Public company branding for the careers pages, fetched once per company slug. */
const usePublicBranding = (companyslug) => {
  const [branding, setBranding] = useState(() => brandingCache.get(companyslug) || null);
  const [loading, setLoading] = useState(!brandingCache.has(companyslug));

  useEffect(() => {
    let active = true;
    if (brandingCache.has(companyslug)) {
      setBranding(brandingCache.get(companyslug));
      setLoading(false);
      return undefined;
    }
    (async () => {
      let resolved = DEFAULT_BRANDING;
      try {
        const response = await Service.makeAPICall({
          methodName: Service.getMethod,
          api_url: Service.publicCareerBranding(companyslug),
        });
        if (response?.data?.status === 200 && response.data.data) {
          resolved = { ...DEFAULT_BRANDING, ...response.data.data };
          brandingCache.set(companyslug, resolved);
        }
      } catch (error) {
        resolved = DEFAULT_BRANDING;
      }
      if (active) {
        setBranding(resolved);
        setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [companyslug]);

  return { branding: branding || DEFAULT_BRANDING, loading };
};

export default usePublicBranding;
